import {debounce} from "lodash"
import LazyLoad from "vanilla-lazyload";
import Swiper, {Navigation, Mousewheel, Keyboard, Lazy, Autoplay, EffectFade, Virtual} from "swiper"
import ScrollMotion from "@neoflow/scrollmotion"
import createJustifiedLayout from "justified-layout"

import 'swiper/swiper-bundle.css';
import 'animate.css/source/_vars.css'
import 'animate.css/source/_base.css'
import 'animate.css/source/fading_entrances/fadeIn.css'
import 'animate.css/source/zooming_entrances/zoomIn.css'

Swiper.use([Navigation, Mousewheel, Keyboard, Lazy, Virtual, EffectFade, Autoplay])

const scrollMotion = new ScrollMotion();
scrollMotion.start()

const years = document.getElementById('years')
const episodes = document.getElementById('episodes')
if (years && episodes) {
  const FLIP = document.location.search.indexOf('flip=true') !== -1;
  const yearsSwiper = new Swiper(years, {
    initialSlide: FLIP ? 0 : years.querySelectorAll('.swiper-slide').length - 1,
    slidesPerView: 3,
    spaceBetween: 20,
    centeredSlides: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 8,
        spaceBetween: 30,
      },
    }
  })

  const episodesSwiper = new Swiper(episodes, {
    slidesPerView: 'auto',
    initialSlide: FLIP ? 0 : episodes.querySelectorAll('.swiper-slide').length - 1,
    // centeredSlides: true,
    spaceBetween: 0,
    slideToClickedSlide: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      disabledClass: 'opacity-0',
      nextEl: '.episodes-navigation-next',
      prevEl: '.episodes-navigation-prev',
    }
  })


  yearsSwiper.on('slideChange', (swiper) => {
    const {activeIndex, slides} = swiper;
    const activeSlide = slides[activeIndex]
    // @ts-ignore
    const {year} = activeSlide.dataset;
    if (year) {
      const episodesSlides = episodesSwiper.slides;
      const firstSlideOfYear = Array.from(episodesSlides).find(e => e.dataset.year === year);
      const index = episodesSlides.indexOf(firstSlideOfYear)
      episodesSwiper.slideTo(index, 600)
    }
  });
}


const photowall = document.getElementById('photowall')
if (photowall) {
  const {justifiedLayoutOptions} = photowall.dataset
  const options = justifiedLayoutOptions && JSON.parse(justifiedLayoutOptions);

  // Set up justified layout
  // @ts-ignore
  const images = Array.from(photowall.querySelectorAll('img'))
  const ratios = images.map(img => 1 / Number(img.dataset.ratio))

  const renderJustifiedLayout = debounce(() => {
    const {width: containerWidth} = photowall.getBoundingClientRect()
    const layout = createJustifiedLayout(ratios, {
      containerWidth,
      containerPadding: 0,
      targetRowHeight: 200,
      ...options
    })
    photowall.style.height = layout.containerHeight + 'px'
    images.forEach(image => {
      image.parentNode.style.display = 'none'
    })
    layout.boxes.forEach((box, index) => {
      const image = images[index];
      const css = `display: block;
        top: ${box.top}px;
        left: ${box.left}px;
        height: ${box.height}px;
        width: ${box.width}px`;
      image.parentNode.style.cssText = css
    })
    // setTimeout(() => {
    new LazyLoad({use_native: true});
    // }, 100)
  }, 300)

  window.addEventListener('load', renderJustifiedLayout)
  window.addEventListener('resize', renderJustifiedLayout)
}

const photowallSwiper = document.getElementById('photowall-swiper')
if (photowallSwiper && photowall) {
  const links = photowall.querySelectorAll('a');
  const slides = []
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    slides.push({
      src: link.getAttribute('href'),
      caption: link.getAttribute('title'),
    })
  }

  // @ts-ignore
  const swiper = new Swiper(photowallSwiper.querySelector('.swiper'), {
    preloadImages: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    grabCursor: true,
    autoplay: {
      waitForTransition: false,
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    lazy: {
      enabled: true
    },
    keyboard: {
      enabled: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    virtual: {
      slides,
      enabled: true,
      renderSlide(slide, index) {
        const caption = slide.caption ?
          `<figcaption class="animate animate__fadeIn text-center text-base text-white bg-black/50 mt-4 p-4 absolute bottom-0 inset-x-0" >
           ${slide.caption}
          </figcaption>` : '';
        return `
          <div class="swiper-slide flex items-center justify-center">
            <div class="text-white/20 text-sm absolute top-0 left-0 p-4" >${index + 1} / ${slides.length}</div>
            <figure class="p-8 h-full w-full flex items-center justify-center">
              <img style="object-fit: contain; width: 100%; height: 100%; max-height: 80vh; max-width: 80vw;"
              class="swiper-lazy"
              src="${slide.src}">
              <div class="swiper-lazy-preloader"></div>
              ${caption}
            </figure>
          </div>
        `
      }
    }
  });

  photowall.addEventListener('click', (ev) => {
    ev.preventDefault();
    const index = Array.from(links).indexOf(ev.target.parentElement)
    swiper.slideTo(index - 1)
    photowallSwiper.classList.remove('hidden')
    setTimeout(() => swiper.slideTo(index), 1)
  });

  const playButton = document.querySelector('[data-action="play"]')
  const pauseButton = document.querySelector('[data-action="pause"]');

  (window as any).AUTOPLAY = swiper.autoplay
  const togglePlayPause = () => {
    console.log(swiper.autoplay);
    if (swiper.autoplay.running) {
      swiper.autoplay.stop();
      pauseButton.classList.add('hidden');
      playButton.classList.remove('hidden');
    } else {
      swiper.autoplay.start();
      playButton.classList.add('hidden');
      pauseButton.classList.remove('hidden');
    }
  }

  playButton.addEventListener('click', () => {
    togglePlayPause()
  })

  pauseButton.addEventListener('click', () => {
    togglePlayPause()
  })

  document.querySelector('[data-action="close"]').addEventListener('click', () => {
    photowallSwiper.classList.add('hidden')
  })

  photowallSwiper.addEventListener('click', (ev) => {
    if (ev.target.classList.contains('swiper-slide')) {
      photowallSwiper.classList.add('hidden')
    }
  })

}

const hero = document.getElementById('hero')
const navBg = document.getElementById('nav-bg')

if (hero) {
  let heroHeight;
  let navBgHeight;
  const measureHeroHeight = () => {
    heroHeight = hero.getBoundingClientRect().height
    navBgHeight = navBg.getBoundingClientRect().height
    fadeOutHero()
  }
  const fadeOutHero = () => {
    const opacity = Math.max(0, (heroHeight - window.scrollY - navBgHeight) / (heroHeight - navBgHeight))
    hero.style.opacity = `${opacity}`;
    // navBg.style.display = !opacity ? 'block' : 'none'
  }
  window.addEventListener('resize', measureHeroHeight)
  window.addEventListener('load', measureHeroHeight)
  window.addEventListener('scroll', fadeOutHero, {passive: true})
}


const audioPlayer = document.querySelector("audio.audio-player")
if (audioPlayer) {
  console.log(audioPlayer);
}
